<template>
    <div>
      <ui-modal ref="reporte-pa-modal" title="Reporte de planificacion anual" size="large" @close="closeReportModal()">
  
        <div>
            
            <!-- Años -->
            <ui-select
                class="w-100 mr-3"
                has-search
                label="Año"
                placeholder="Seleccionar"
                searchPlaceholder="Buscar"
                :keys="{ label: 'year', value: 'id' }"
                :options="listaAnios"
                v-model="anioModel"
                @change="habilitarBtn"
            />

            <!-- Empresas -->
            <ui-select
                class="w-100 mr-3"
                has-search
                label="Empresas"
                placeholder="Seleccionar"
                searchPlaceholder="Buscar"
                :keys="{ label: 'name', value: 'id' }"
                :options="listaClientesUsuarioActual"
                v-model="clientesModel"
                @change="habilitarBtn"
                v-if="showSelectClientes"
            />

            <!-- Pallet -->
            <ui-select
                class="w-100 mr-3"
                has-search
                label="Pallet"
                placeholder="Seleccionar"
                searchPlaceholder="Buscar"
                :keys="{ label: 'name', value: 'id' }"
                :options="listaPallet"
                v-model="palletsModel"
                @change="habilitarBtn"
            />
            
        </div>

        <div class="d-flex justify-content-between mt-5">
          <div style="float: left;">
            <button class="btn btn-default ml-2" @click="closeReportModal">Cerrar</button>
            <button class="btn btn-default ml-2" @click="clear()">Limpiar</button>
          </div>

          <div style="float: right;">
            <button class="btn btn-outline-danger ml-2" :disabled="disabledButton" @click="generarReporte()">Generar reporte</button>
          </div>
        </div>
      </ui-modal>
    </div>
  </template>
  
  <script>
  
  import UiModal from "keen-ui/src/UiModal";
  import { mapActions, mapState } from "vuex";
  import { downloadReportePlanificacionAnualCharter } from "@/constants/charter";
  import uuid from "keen-ui/src/helpers/uuid";
  
  export default {
    components: { UiModal },
    data() {
      return {
        disabledButton: false,
        anioModel: "",
        clientesModel : "",
        palletsModel : "",
        showSelectClientes : false
      };
    },
    computed: {
        ...mapState(["listaClientesUsuarioActual","usuarioActual"]),

        ...mapState("charter", [
            "paShowReportModal",
            "listaAnios",
            "listaPallet"
        ]
      )
    },
    methods: {
        ...mapActions(["ActionSetZindexTablaModal"]),
        ...mapActions("charter", [
            "actionSetPAShowReportModal"
        ]),

        openModal(ref) {
            this.$refs[ref].open();
        },

        closeModal(ref) {
            this.$refs[ref].close();
        },

        clear() {
            this.anioModel = [];
            this.clientesModel = [];
            this.palletsModel = [];
            this.disabledButton = true;
        },

        closeReportModal() {
            this.ActionSetZindexTablaModal(false);
            this.actionSetPAShowReportModal(false);
            this.closeModal("reporte-pa-modal");
        },

        async generarReporte() {
    
            this.$vToastify.loader("Exportando reporte planificaciones anuales...");
    
            await downloadReportePlanificacionAnualCharter({
                    client_id: this.clientesModel.id ?? null,
                    pallet_id: this.palletsModel.id ?? null,
                    year: this.anioModel.id ?? null,
                },

                uuid.short("reporte-planificacion-anual-ucc-")

            );
    
            this.closeReportModal();
    
            this.$vToastify.stopLoader();
    
            this.disabledButton = false;
    
        },

        habilitarBtn() {
            let me = this;

            Object.keys(me.anioModel).length > 0 ||
            Object.keys(me.clientesModel).length > 0 ||
            Object.keys(me.palletsModel).length > 0
            ? (me.disabledButton = false)
            : (me.disabledButton = true);

        },
    },

    mounted(){

        if (this.usuarioActual.rol == 'Administrador' || this.usuarioActual.rol == "Ejecutivo" || this.usuarioActual.rol == "Super Administrador") {
        
            this.showSelectClientes = true;

        }else{

            this.showSelectClientes = false;
            this.clienteMclientesModelodel = [{id:this.usuarioActual.id_cliente, name:this.usuarioActual.cliente}];

        }

    },

    watch: {
      paShowReportModal: function(_new) {
        if (_new) {
          this.openModal("reporte-pa-modal");
        }
      },
     
    }
  };
  </script>
  
  <style>
  
  </style>